/*---------------------------------------------------------------------------------------------
 *  Copyright (c) i-Bridge Systems Philippines Inc. All rights reserved.
 *--------------------------------------------------------------------------------------------*/
import { Modal, Fade, Backdrop, Box } from '@mui/material';
import '../../css/EditModal.css';

export const BigModal = (props) => {
  const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: props.width || 500,
    maxHeight: '80vh',
    maxWidth: '95vw',
    overflowY: 'auto',
    bgcolor: 'background.default',
    boxShadow: 24,
    p: 4,
    borderRadius: '5px',
  };

  return (
    <Modal
      open={props.open}
      onClose={props.onClose}
      disableEscapeKeyDown={props.lockClose}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal=modal-description"
      closeAfterTransition
      BackdropComponent={Backdrop}
      BackdropProps={{ timeout: 500 }}
    >
      <Fade in={props.open}>
        <Box sx={style}>{props.children}</Box>
      </Fade>
    </Modal>
  );
};
